(() => {
  const strings = window.WSTheme?.strings || {};
  const routes = window.WSTheme?.routes || {};
  const onThisPage = strings.legalOnThisPage || 'On this page';
  const storefrontHome = strings.storefrontHome || 'Home';
  const normalize = (value) => value.replace(/\s+/g, ' ').trim().toLocaleLowerCase();
  const createToc = (className, label, listAttribute) => {
    const toc = document.createElement('aside');
    toc.className = className;
    toc.hidden = true;
    toc.setAttribute('data-legal-toc', '');
    toc.setAttribute('aria-label', label);
    toc.innerHTML = `<p class="legal-shell__toc-title legal-page__toc-title">${label}</p><ol class="legal-shell__toc-list legal-page__toc-list" ${listAttribute}></ol>`;
    return toc;
  };
  const createMobileToc = () => {
    const toc = document.createElement('details');
    toc.className = 'legal-shell__mobile-toc';
    toc.hidden = true;
    toc.setAttribute('data-legal-mobile-toc', '');
    toc.innerHTML = `<summary>${onThisPage}</summary><ol class="legal-shell__mobile-toc-list" data-legal-mobile-toc-list></ol>`;
    return toc;
  };
  const policy = document.querySelector('.shopify-policy__container');
  const customPage = document.querySelector('[data-legal-page]');
  if (!policy && !customPage) return;

  let shell = customPage;
  let content = customPage?.querySelector('.legal-shell__content, .legal-page__content');
  let desktopToc = customPage?.querySelector('[data-legal-toc]');
  let mobileToc = customPage?.querySelector('[data-legal-mobile-toc]');
  let title = customPage?.dataset.legalTitle || customPage?.querySelector('h1')?.textContent || '';

  if (!shell && policy) {
    shell = policy;
    shell.classList.add('legal-shell');
    content = policy.querySelector('.shopify-policy__body');
    const titleNode = policy.querySelector('.shopify-policy__title h1');
    title = titleNode?.textContent || '';
    shell.dataset.legalTitle = title;
    const breadcrumb = document.createElement('nav');
    breadcrumb.className = 'breadcrumb legal-shell__breadcrumb';
    breadcrumb.setAttribute('aria-label', 'Breadcrumb');
    breadcrumb.innerHTML = `<a href="${routes.root || '/'}">${storefrontHome}</a><span aria-hidden="true">›</span><span aria-current="page"></span>`;
    breadcrumb.querySelector('[aria-current="page"]').textContent = title;
    policy.insertBefore(breadcrumb, policy.firstChild);
    const grid = document.createElement('div');
    grid.className = 'legal-shell__grid legal-page__layout';
    desktopToc = createToc('legal-shell__toc legal-page__toc', onThisPage, 'data-legal-toc-list');
    mobileToc = createMobileToc();
    content.parentNode.insertBefore(grid, content);
    grid.append(desktopToc, mobileToc, content);
    content.classList.add('legal-shell__content', 'legal-page__content');
  }
  if (!content || !desktopToc || !mobileToc) return;

  const urlPattern = /https?:\/\/[^\s<]+/g;
  const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  while (walker.nextNode()) {
    const node = walker.currentNode;
    if (node.parentElement?.closest('a, script, style')) continue;
    if (urlPattern.test(node.nodeValue)) textNodes.push(node);
    urlPattern.lastIndex = 0;
  }
  textNodes.forEach((node) => {
    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    node.nodeValue.replace(urlPattern, (match, offset) => {
      fragment.append(document.createTextNode(node.nodeValue.slice(lastIndex, offset)));
      const link = document.createElement('a');
      link.href = match;
      link.textContent = match;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      fragment.append(link);
      lastIndex = offset + match.length;
      return match;
    });
    fragment.append(document.createTextNode(node.nodeValue.slice(lastIndex)));
    node.replaceWith(fragment);
  });  if (policy && /datenschutz/i.test(title)) {
    content.querySelectorAll('p').forEach((paragraph) => {
      if (/telefonisch unter\s*,?/i.test(paragraph.textContent) && /sperling@passerida-labs\.com/i.test(paragraph.textContent)) {
        paragraph.innerHTML = 'Sollten Sie Fragen zu unseren Datenschutzverfahren oder dieser Datenschutzerklärung haben oder eines Ihrer Rechte ausüben möchten, wenden Sie sich bitte telefonisch unter <a href="tel:+4915120132943">+49 151 20132943</a> oder per E-Mail unter <a href="mailto:hello@wundersaam.com">hello@wundersaam.com</a> an uns. Im Sinne der geltenden Datenschutzgesetze ist wundersaam der Verantwortliche für Ihre personenbezogenen Daten.';
      }
    });
  }  const normalizedTitle = normalize(title);
  content.querySelectorAll('h1').forEach((heading) => {
    if (normalize(heading.textContent) === normalizedTitle) {
      heading.hidden = true;
      heading.setAttribute('aria-hidden', 'true');
      heading.dataset.legalDuplicateTitle = 'true';
    }
  });

  const h2Headings = Array.from(content.querySelectorAll('h2'));
  if (h2Headings.length < 4) return;
  const usedIds = new Set(Array.from(document.querySelectorAll('[id]')).map((node) => node.id));
  const slugify = (value, index) => {
    const base = value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || `abschnitt-${index + 1}`;
    let id = base;
    let suffix = 2;
    while (usedIds.has(id)) id = `${base}-${suffix++}`;
    usedIds.add(id);
    return id;
  };
  const desktopList = desktopToc.querySelector('[data-legal-toc-list]');
  const mobileList = mobileToc.querySelector('[data-legal-mobile-toc-list]');
  h2Headings.forEach((heading, index) => {
    heading.id = heading.id || slugify(heading.textContent.trim(), index);
    [desktopList, mobileList].forEach((list) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
    });
  });
  desktopToc.hidden = false;
  mobileToc.hidden = false;
})();